import { createFileRoute } from "@tanstack/react-router";
import { marketingHead } from "../marketing-content/head";
import { MarketingSkillsPage } from "../components/marketing/MarketingSkillsPage";

export const Route = createFileRoute("/product/skills")({
  head: () => marketingHead("/product/skills"),
  component: MarketingSkillsPage,
});
